var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ticket-card',{staticClass:"ma-2",attrs:{"ticket":_vm.source},on:{"click":function($event){return _vm.$emit('open-ticket', _vm.source.ticket)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }